/**
 * S0a′ 골목 걷기 전환 (시안 05 README 6장 S0a′ · 4.5 MO1, 결정 20) → S0·T1 문이 열린다 → 카운터.
 *
 * 글자 없이 골목 사진이 2초 동안 가게 문으로 다가가 카운터 사진(주전자 김)으로 넘어갑니다. 탭 = 건너뛰기,
 * 뒤로 가기는 막습니다. 첫 방문을 이어서 열 때(멈춘 장면 = 골목)도 이 전환부터입니다.
 *
 * 골목 화면의 고지 3줄 · 동의는 없앴습니다(D45). 약관 · 고지 동의는 소셜 가입 단계에서 따로 받을 예정이고,
 * 「멤버들은 AI가 연기하는 가상 인물이에요」는 별채 문(S0·T2)에서 그대로 알립니다. 여기서는 카운터로 넘어가는
 * 것만 서버에 알립니다(POST /api/welcome/enter, 동의 기록 없음).
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { errorMessageOf } from '../../api/client.js';
import * as counterApi from '../../api/counter.js';
import { useSession } from '../../stores/session.js';
import { CounterTransition, sceneUrl } from './SceneCards.jsx';
import { WalkIn } from './SceneMotion.jsx';
import { portraitUrlOf } from '../../components/Avatar.jsx';
import { useBlockBack } from '../../hooks/useBlockBack.js';
import { useDarkChrome } from '../../hooks/useDarkChrome.js';

export function WelcomePage() {
    const navigate = useNavigate();
    const setUser = useSession((state) => state.setUser);
    useDarkChrome();
    const [stage, setStage] = useState('walk');
    const [entered, setEntered] = useState(null);
    const [error, setError] = useState(null);
    const [attempt, setAttempt] = useState(0);
    useBlockBack(stage === 'walk');

    // 카운터 사진은 미리 받아 둡니다(전환 끝에 바로 보이게)
    useEffect(() => {
        for (const src of [sceneUrl('counter'), portraitUrlOf('imo')]) {
            const image = new Image();
            image.src = src;
        }
    }, []);

    useEffect(() => {
        let alive = true;
        setError(null);
        counterApi
            .enterWelcome()
            .then(({ user }) => alive && setEntered(user))
            .catch((requestError) => {
                if (alive) {
                    setError(errorMessageOf(requestError, '문이 잘 안 열리네요. 잠시 후 다시 시도해 주세요.'));
                }
            });
        return () => {
            alive = false;
        };
    }, [attempt]);

    function enterCounter() {
        setUser(entered);
        navigate('/counter', { replace: true });
    }

    // 서버가 답하기 전에 걷기가 끝나면 마지막 장면(카운터 사진)에서 기다립니다
    const walkDone = stage === 'counter';
    return (
        <main className="relative mx-auto min-h-dvh max-w-app overflow-hidden bg-text-primary">
            <button
                type="button"
                aria-label="골목을 지나 가게로 들어가는 중. 누르면 건너뛰어요"
                onClick={() => setStage('counter')}
                className="absolute inset-0 block"
            >
                <WalkIn onDone={() => setStage('counter')} />
            </button>
            {error ? (
                <div className="absolute inset-x-5 bottom-10 flex flex-col items-center gap-3 text-center">
                    <p role="alert" className="m-0 text-caption text-[#FFFDF8]">
                        {error}
                    </p>
                    <button
                        type="button"
                        onClick={() => setAttempt((value) => value + 1)}
                        className="h-12 w-full rounded-card bg-[#FFFDF8] text-[15px] font-semibold text-brand"
                    >
                        다시 들어가기
                    </button>
                </div>
            ) : null}
            {walkDone && entered ? <CounterTransition onNext={enterCounter} fadeIn={false} /> : null}
        </main>
    );
}
